import { atomWithLocalStorage } from "../comments/comments";


const CANVAS_FILTER_OPTION_LOCAL_STORAGE_KEY = "canvasFilterOptions";

interface ICanvasFilterOptions {
    showValidatedHypotheses: boolean;
    showInvalidatedHypotheses: boolean;
    showUnresolvedHypotheses: boolean;
}

const INITIAL_OPTIONS: ICanvasFilterOptions = {
    showValidatedHypotheses: true,
    showInvalidatedHypotheses: true,
    showUnresolvedHypotheses: true,
};

export const canvasFilterOptionsAtom = atomWithLocalStorage(
    CANVAS_FILTER_OPTION_LOCAL_STORAGE_KEY,
    INITIAL_OPTIONS,
    []
);
